var _circle, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#8311B3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_717_2338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5288 39.6219C11.062 33.2978 9.82857 30.1357 11.0269 27.4047C12.2252 24.6737 15.3873 23.4403 21.7115 20.9735L28.4192 18.3571C34.7433 15.8903 37.9055 14.6568 40.6364 15.8552C43.3675 17.0535 44.6008 20.2156 47.0677 26.5397L48.3759 29.8936C50.8426 36.2177 52.0761 39.3799 50.8777 42.1108C49.6795 44.8418 46.5173 46.0753 40.1932 48.5421L33.4854 51.1585C27.1613 53.6253 23.9992 54.8587 21.2682 53.6603C18.5372 52.4621 17.3038 49.2999 14.837 42.9758L13.5288 39.6219Z",
    fill: "#FF8A00"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_717_2338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 36C18 29.2117 18 25.8176 20.1089 23.7088C22.2177 21.6 25.6118 21.6 32.4 21.6H39.6C46.3882 21.6 49.7824 21.6 51.8911 23.7088C54 25.8176 54 29.2117 54 36V39.6C54 46.3881 54 49.7824 51.8911 51.8911C49.7824 54 46.3882 54 39.6 54H32.4C25.6118 54 22.2177 54 20.1089 51.8911C18 49.7824 18 46.3881 18 39.6V36Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 36C18 29.2117 18 25.8176 20.1089 23.7088C22.2177 21.6 25.6118 21.6 32.4 21.6H39.6C46.3882 21.6 49.7824 21.6 51.8911 23.7088C54 25.8176 54 29.2117 54 36V39.6C54 46.3881 54 49.7824 51.8911 51.8911C49.7824 54 46.3882 54 39.6 54H32.4C25.6118 54 22.2177 54 20.1089 51.8911C18 49.7824 18 46.3881 18 39.6V36Z",
    stroke: "white",
    strokeWidth: 2.7
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 21.6V18.9",
    stroke: "white",
    strokeWidth: 2.7,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 21.6V18.9",
    stroke: "white",
    strokeWidth: 2.7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 30.6H53.1",
    stroke: "white",
    strokeWidth: 2.7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8 45C46.8 45.9942 45.9942 46.8 45 46.8C44.0059 46.8 43.2 45.9942 43.2 45C43.2 44.0059 44.0059 43.2 45 43.2C45.9942 43.2 46.8 44.0059 46.8 45Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8 37.8C46.8 38.7941 45.9942 39.6 45 39.6C44.0059 39.6 43.2 38.7941 43.2 37.8C43.2 36.8059 44.0059 36 45 36C45.9942 36 46.8 36.8059 46.8 37.8Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8 45C37.8 45.9942 36.9942 46.8 36 46.8C35.0059 46.8 34.2 45.9942 34.2 45C34.2 44.0059 35.0059 43.2 36 43.2C36.9942 43.2 37.8 44.0059 37.8 45Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8 37.8C37.8 38.7941 36.9942 39.6 36 39.6C35.0059 39.6 34.2 38.7941 34.2 37.8C34.2 36.8059 35.0059 36 36 36C36.9942 36 37.8 36.8059 37.8 37.8Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 45C28.8 45.9942 27.9941 46.8 27 46.8C26.0059 46.8 25.2 45.9942 25.2 45C25.2 44.0059 26.0059 43.2 27 43.2C27.9941 43.2 28.8 44.0059 28.8 45Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 37.8C28.8 38.7941 27.9941 39.6 27 39.6C26.0059 39.6 25.2 38.7941 25.2 37.8C25.2 36.8059 26.0059 36 27 36C27.9941 36 28.8 36.8059 28.8 37.8Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_717_2338",
    x: 3.36421,
    y: 8.19252,
    width: 55.1762,
    height: 53.1305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_717_2338"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_717_2338",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_717_2338",
    x: 9.45002,
    y: 13.05,
    width: 53.1,
    height: 49.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_717_2338"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_717_2338",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.495437c7377133854dd7f6d18f86c97e.svg";
export { ForwardRef as ReactComponent };